import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    id: 'neptune.DateLookup.next',
    defaultMessage: 'next',
    description: 'Description of next button',
  },
  previous: {
    id: 'neptune.DateLookup.previous',
    defaultMessage: 'previous',
    description: 'Description of previous button',
  },
  day: {
    id: 'neptune.DateLookup.day',
    defaultMessage: 'day',
    description: 'Description of next/previous/selected day button',
  },
  month: {
    id: 'neptune.DateLookup.month',
    defaultMessage: 'month',
    description: 'Description of next/previous/selected month button',
  },
  year: {
    id: 'neptune.DateLookup.year',
    defaultMessage: 'year',
    description: 'Description of next/previous/selected year button',
  },
  twentyYears: {
    id: 'neptune.DateLookup.twentyYears',
    defaultMessage: '20 years',
    description: 'Description of next/previous 20 years button',
  },
  selected: {
    id: 'neptune.DateLookup.selected',
    defaultMessage: 'selected',
    description: 'Description of the selected day/month/year',
  },
  goTo20YearView: {
    id: 'neptune.DateLookup.goTo20YearView',
    defaultMessage: 'Go to 20 year view',
    description: 'Description of the button to go to 20 year view',
  },
});
